import React from "react";
import {getTokenDetails, login} from '../providers/providers.js'
import {connect} from 'react-redux'
import store from '../store'
import {withRouter} from 'react-router-dom'
import {Container, Row, Col, Form, Button, Spinner} from "react-bootstrap";
import DisplayStatus from './DisplayStatus'
import VerificationForm from "./VerificationForm";
import {validate} from "../lib/utils";
import BaseComponent from "./BaseComponent";
const Translate = require('react-redux-i18n').Translate;
const I18n = require('react-redux-i18n').I18n;


const stateMap = (store) => {
    return {
        user: store.user
    };
};

class Login extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = {
            username: '',
            otp: '',
            usernameError: '',
            otpError: '',
            loginError: undefined,
            showError: false,
            redirect: false,
            loading: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAlert = this.handleAlert.bind(this)

    }


   handleAlert(show){
        this.setState({
            showError: show
        })
    }


    handleChange(event) {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const validationResult = validate(this.state.username, this.state.otp);
        this.setState({
            usernameError: validationResult.usernameError,
            otpError: validationResult.otpError
        });
        if (!validationResult.isValid) return;
        store.dispatch(login(this.state.username, this.state.otp))
            .then((response) => {
                store.dispatch(getTokenDetails())
                    .then((response) => {
                            this.props.history.push('/')
                        }
                    )
            }, (error)=> {
                this.setState({
                    loginError: I18n.t("login.error"),
                    showError: true
                })
            })
    }


    render() {
        return (
            <Container className="login-frm">
                <Row className="justify-content-md-center">
                    <Col lg="6">
                        <Form onSubmit={this.handleSubmit}>
                                <VerificationForm
                                    handleChange={this.handleChange}
                                    username={this.state.username}
                                    otp={this.state.otp}
                                    usernameError={this.state.usernameError}
                                    otpError={this.state.otpError} />
                            <Row>
                                <Col>
                                    {this.props.user && this.props.user.entity.fetching ?
                                    <Spinner animation="border" variant="info" className="bs-spinner spinner__custom-clr" />: null}
                                    <Button variant="primary" type="submit" className="login-btn">
                                        <Translate value="button.submit"/>
                                    </Button>
                                </Col>
                            </Row>
                            <DisplayStatus
                                statusMessage={this.state.loginError}
                                statusType={"error"}
                                showAlert={this.state.showError}
                                handleAlert={this.handleAlert}
                                dismissible={true}
                            />
                        </Form>
                    </Col>
                </Row>
            </Container>
        )
    }
}






export default withRouter(connect(stateMap)(Login));